import type {ReactNode} from 'react'

/** El chip va en una caja `w-fit`: en `flex-col`/`grid` un `Tag` se estira a la columna. `porque` es
 * `string` a propósito, para que no quepa un `PorQue` por fila (U4). */
export function CeldaEstado({
  chip,
  nombre,
  meta,
  porque,
  porqueTestId,
}: {
  /** Uno o dos `<Tag>` con el estado de la fila, ≤ 3 palabras cada uno. */
  chip?: ReactNode
  nombre?: ReactNode
  meta?: ReactNode
  /** Va a `title` + `sr-only`, nunca a un disparador. */
  porque?: string
  porqueTestId?: string
}) {
  return (
    <div className="min-w-0 space-y-1" title={porque}>
      {(chip || nombre) && (
        <div className="flex flex-wrap items-center gap-2">
          {chip && <span className="flex w-fit min-w-0 items-center gap-1">{chip}</span>}
          {nombre && <span className="font-medium">{nombre}</span>}
        </div>
      )}
      {/* `div` y no `p`: `meta` recibe nodos del llamador y un párrafo no admite contenido de bloque. */}
      {meta && <div className="text-xs text-muted-foreground">{meta}</div>}
      {porque && (
        <span className="sr-only" data-testid={porqueTestId}>
          {porque}
        </span>
      )}
    </div>
  )
}

/** Un solo acto por fila (R2); el secundario va escrito chico, no como botón. */
export function CeldaActo({acto, secundario}: {acto?: ReactNode; secundario?: ReactNode}) {
  if (!acto && !secundario) return null
  return (
    <div className="flex flex-col items-end gap-1">
      {acto}
      {secundario}
    </div>
  )
}
